import { Control } from 'react-hook-form';
import { FC } from 'react';
import api from 'lib/trpcClient';
import { investee as Investee } from 'further-ui/validations';
import SelectionWithRadio from '../SelectionWithRadio';

type CompanySelectionProps = {
  isNewCompany: boolean;
  control: Control<
    Investee.NewCompanyFormValues | Investee.NewShareClassFormValues
  >;
  resetCompanyDropdown: () => void;
  onCompanyChange: (name: string) => void;
  firmId: string;
};

const CompanySelection: FC<CompanySelectionProps> = ({
  isNewCompany,
  control,
  resetCompanyDropdown,
  onCompanyChange,
  firmId,
}) => {
  const { data: companies, isFetching } =
    api.investee.listUniqueInvestees.useQuery(
      {
        firmId,
      },
      {
        enabled: !!firmId,
        staleTime: 0,
        refetchOnWindowFocus: true,
      },
    );

  return (
    <SelectionWithRadio
      control={control}
      isNewFieldName="isNewCompany"
      selectionFieldName="investeeId"
      existingLabel="Select existing company"
      newLabel="Create new company and share class"
      newHelperText="Select if the company is not yet in the system"
      selectBoxProps={{
        data: companies?.result || [],
        placeholder: 'Select company',
        valueKey: '_id',
        labelKey: 'legalName',
        disabled: isNewCompany,
        isLoading: isFetching,
      }}
      onSelectionChange={onCompanyChange}
      onNewSelection={() => {
        resetCompanyDropdown();
        onCompanyChange('');
      }}
    />
  );
};

export default CompanySelection;
